<template>
  <li :class="['hover:bg-gray-500 p-2 cursor-pointer', $store.state.asideTab === props.tab ? 'bg-gray-500' : '']" @click="changeTab(props.tab)">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-1">
        <span class="text-gray-200"><i :class="props.icon"></i></span>
        <span class="text-gray-200">{{props.menu}}</span>
      </div>
      <span v-if="$store.state.asideTab !== props.tab">
        <font-awesome-icon icon="fa-solid fa-chevron-left" class="icon text-gray-200 fm:text-sm"/>
      </span>
      <span v-else>
        <font-awesome-icon icon="fa-solid fa-chevron-left" class="icon text-gray-200 fm:text-sm"/>
      </span>
    </div>
  </li>
  <li v-if="$store.state.asideTab === props.tab">
    <ul class="flex flex-col">
      <li v-for="submenu in props.submenus" :key="submenu.id">
        <div class="hover:bg-gray-500 p-2 pr-6 cursor-pointer" v-if="(submenu.perm === undefined || store.getters.userCan(submenu.perm,'include')) && (submenu.show === undefined || submenu.show)">
          <routerLink :to="submenu.route" class="text-gray-200">{{submenu.title}}</routerLink>
        </div>
      </li>
    </ul>
  </li>
</template>

<script>
export default{name:"DashboardAside"}
</script>

<script setup>
import {ref, defineProps, onMounted} from "vue";
import store from "@/store";

onMounted(()=>{
  store.state.asideTab += 1
})

const props = defineProps({
  "tab":{
    type:Number,
    default:0
  },
  "icon":{
    type:String,
    default:""
  },
  "menu":{
    type:String,
    default:""
  },
  "submenus":{
    type:Array
  }
});
function changeTab(_tab){
  store.state.asideTab = _tab === store.state.asideTab ? 0 : _tab;
}

</script>